import { render, staticRenderFns } from "./CreateTeam.vue?vue&type=template&id=5d34d20a&scoped=true&"
import script from "./CreateTeam.vue?vue&type=script&lang=js&"
export * from "./CreateTeam.vue?vue&type=script&lang=js&"
import style0 from "./CreateTeam.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CreateTeam.vue?vue&type=style&index=1&id=5d34d20a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d34d20a",
  null
  
)

export default component.exports